import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.68751 1.16699C4.80155 1.16699 4.08334 1.8852 4.08334 2.77116V2.91699H3.93751C3.05155 2.91699 2.33334 3.6352 2.33334 4.52116V11.2295C2.33334 12.1154 3.05155 12.8337 3.93751 12.8337H8.89584C9.7818 12.8337 10.5 12.1154 10.5 11.2295V11.0837H10.6458C11.5318 11.0837 12.25 10.3654 12.25 9.47949V4.95866H10.0625C9.17655 4.95866 8.45834 4.24045 8.45834 3.35449V1.16699H5.68751ZM9.62501 11.0837H5.68751C4.80155 11.0837 4.08334 10.3654 4.08334 9.47949V3.79199H3.93751C3.5348 3.79199 3.20834 4.11845 3.20834 4.52116V11.2295C3.20834 11.6322 3.5348 11.9587 3.93751 11.9587H8.89584C9.29855 11.9587 9.62501 11.6322 9.62501 11.2295V11.0837Z",
      fill: "black",
      "fill-opacity": "0.9"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.33334 1.42327L11.9937 4.08366H10.0625C9.6598 4.08366 9.33334 3.7572 9.33334 3.35449V1.42327Z",
      fill: "black",
      "fill-opacity": "0.9"
    }, null, -1)
  ])))
}
export default { render: render }